// Tiny factory for the context object selection-region writers (region
// panel publisher, moveSelection intent) hand to updateSelectedRegion. The
// closure shape is identical at every call site; this lives next to
// scene/selection.ts so the two evolve together.

import { threeJSToPhysical } from '@adapters/coordinates';
import { getFieldValue } from '../physics/probe';
import { strengthToColor } from '../physics/colormap';
import type { ColorRGBA, FieldMetadata } from '../physics/types';
import type { Viewer, ParamsLike } from './types';
import type * as THREE from 'three';

export interface RegionContext {
  threeJSToPhysical(x: number, y: number, z: number): THREE.Vector3;
  getFieldValue(x: number, y: number, z: number): number;
  fieldMetadata: FieldMetadata | Partial<FieldMetadata> | null;
  UNITS: string;
  fieldStrengthToColor(strength: number): ColorRGBA;
}

export function buildRegionContext(viewer: Viewer, params: ParamsLike): RegionContext {
  return {
    threeJSToPhysical,
    getFieldValue: (x, y, z) => getFieldValue(viewer, x, y, z),
    fieldMetadata: viewer.field.metadata,
    UNITS: viewer.sceneMeta.units,
    fieldStrengthToColor: (s) => strengthToColor(viewer, params, s),
  };
}
